<nav class="menu-course">
  <span class="top-text">{{toUpperCase(currentCourse?.attributes?.title)}}</span>
  <span class="card-percent">{{progress}}%&nbsp; &nbsp;<span class="card-text-percent">completado</span></span>
  <div class="progress">
    <div
        class="progress-bar"
        role="progressbar"
        [style.width]="progress + '%'"
        aria-valuemin="0"
        aria-valuemax="100">
    </div>
  </div>
  <section class="navegation">
    <ul class="list-menu">
      <li>
        <a
          [routerLink]="['/cursos' + course?.attributes?.path?.alias]"
          class="link main-page"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="circle">{{lengthActivities}}</span><span class="text">Página principal</span>
        </a>
      </li>
      <li *ngFor="let m of modulesCurrentCourse, let i = index" class="options" [ngClass]="{ 'disabled-link': !isModuleClickable(i) }">
        <a
          class="link"
          (click)="toggleSubmenu(i)"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="#4F0B7B" [ngClass]="evaluationPassed[i] && allLessonsCompleted(i)  ? 'circle2-completed' : 'circle2'">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M22.6331 9.00101C22.9842 9.28273 23.0438 9.80006 22.7663 10.1565L13.4494 22.1234C13.2519 22.3849 12.9963 22.5954 12.7033 22.7374C12.4078 22.8808 12.0827 22.9504 11.7553 22.9404C11.4278 22.9305 11.1075 22.8413 10.8208 22.6803C10.5374 22.5211 10.295 22.2962 10.1134 22.024L7.20659 17.8359C6.94881 17.4646 7.03641 16.9513 7.40224 16.6896C7.76807 16.428 8.2736 16.5169 8.53138 16.8883L11.4431 21.0834C11.4468 21.0887 11.4505 21.0941 11.4541 21.0996C11.4927 21.1582 11.5446 21.2066 11.6054 21.2407C11.6663 21.2749 11.7342 21.2938 11.8037 21.2959C11.8731 21.298 11.9421 21.2833 12.0048 21.2529C12.0675 21.2224 12.1222 21.1773 12.1642 21.1211C12.1673 21.1169 12.1705 21.1127 12.1737 21.1086L21.4949 9.13629C21.7724 8.77986 22.282 8.71929 22.6331 9.00101Z"/>
        </svg>
          <span
           class="text" [ngClass]="{ 'disabled-link': !isModuleClickable(i) }">{{m.attributes.title}}</span>
        <img
          src="../../../assets/icons/arrow-filter-tribe-icon.svg"
          alt="arrow filter icon"
          class="arrow"
          [class.arrow-rotated]="submenuAbierto === i"
        />
        </a>
        <ul class="suboptions" *ngIf="submenuAbierto === i" [@openClose]="submenuAbierto === i ? 'open' : 'closed'">
          <li><a class="sub-link" *ngFor="let l of lessonsCurrentCourse[i]"
            [routerLink]="['/cursos' + course?.attributes?.path?.alias + l.attributes.path.alias]" routerLinkActive="active2"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 30 30" fill="#4F0B7B" [ngClass]="lessonIsCompleted(l) ? 'circle3-completed' : 'circle3'">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.6331 9.00101C22.9842 9.28273 23.0438 9.80006 22.7663 10.1565L13.4494 22.1234C13.2519 22.3849 12.9963 22.5954 12.7033 22.7374C12.4078 22.8808 12.0827 22.9504 11.7553 22.9404C11.4278 22.9305 11.1075 22.8413 10.8208 22.6803C10.5374 22.5211 10.295 22.2962 10.1134 22.024L7.20659 17.8359C6.94881 17.4646 7.03641 16.9513 7.40224 16.6896C7.76807 16.428 8.2736 16.5169 8.53138 16.8883L11.4431 21.0834C11.4468 21.0887 11.4505 21.0941 11.4541 21.0996C11.4927 21.1582 11.5446 21.2066 11.6054 21.2407C11.6663 21.2749 11.7342 21.2938 11.8037 21.2959C11.8731 21.298 11.9421 21.2833 12.0048 21.2529C12.0675 21.2224 12.1222 21.1773 12.1642 21.1211C12.1673 21.1169 12.1705 21.1127 12.1737 21.1086L21.4949 9.13629C21.7724 8.77986 22.282 8.71929 22.6331 9.00101Z"/>
            </svg>
            {{l.attributes.title}}
          </a></li>
          <li>
            <a class="sub-link" *ngFor="let evaluation of evaluations[i]"
            [routerLink]="allLessonsCompleted(i) ? ['/cursos' + course?.attributes?.path?.alias + '/evaluacion' + evaluation.attributes.path.alias] : null"
            routerLinkActive="active2"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="{ 'disabled-link': !allLessonsCompleted(i) }">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 30 30" fill="#4F0B7B" [ngClass]="evaluationPassed[i] ? 'circle3-completed' : 'circle3'">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.6331 9.00101C22.9842 9.28273 23.0438 9.80006 22.7663 10.1565L13.4494 22.1234C13.2519 22.3849 12.9963 22.5954 12.7033 22.7374C12.4078 22.8808 12.0827 22.9504 11.7553 22.9404C11.4278 22.9305 11.1075 22.8413 10.8208 22.6803C10.5374 22.5211 10.295 22.2962 10.1134 22.024L7.20659 17.8359C6.94881 17.4646 7.03641 16.9513 7.40224 16.6896C7.76807 16.428 8.2736 16.5169 8.53138 16.8883L11.4431 21.0834C11.4468 21.0887 11.4505 21.0941 11.4541 21.0996C11.4927 21.1582 11.5446 21.2066 11.6054 21.2407C11.6663 21.2749 11.7342 21.2938 11.8037 21.2959C11.8731 21.298 11.9421 21.2833 12.0048 21.2529C12.0675 21.2224 12.1222 21.1773 12.1642 21.1211C12.1673 21.1169 12.1705 21.1127 12.1737 21.1086L21.4949 9.13629C21.7724 8.77986 22.282 8.71929 22.6331 9.00101Z"/>
            </svg>
            {{evaluation.attributes.title}}
          </a>
        </li>
        </ul>
      </li>
    </ul>
  </section>
  <!-- <app-loader *ngIf="isLoading"></app-loader> -->
</nav>

